import { dataListOrdered } from 'dls-icons-data'
import { createIcon } from '../common'

const IconListOrdered = /*#__PURE__*/createIcon(dataListOrdered)
export default IconListOrdered
